(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editorial-column-mab"] && !Shopify.designMode) return;
  try {
    function faqBuildAccordion(question, contentNodes, openByDefault) {
    const acc = document.createElement('accordion-custom');
    if (openByDefault) {
      acc.setAttribute('open-by-default-on-mobile', '');
      acc.setAttribute('open-by-default-on-desktop', '');
    }
    const details = document.createElement('details');
    details.className = 'details faq-accordion__item';

    const summary = document.createElement('summary');
    summary.className = 'details__header faq-accordion__question';
    summary.textContent = question;

    const content = document.createElement('div');
    content.className = 'details-content faq-accordion__answer';
    for (const node of contentNodes) {
      content.appendChild(node);
    }

    details.appendChild(summary);
    details.appendChild(content);
    acc.appendChild(details);
    return acc;
  }

  function faqUpgradeBody(body) {
    const children = Array.from(body.childNodes);
    const result = [];
    let i = 0;
    let isFirstGlobally = true;

    while (i < children.length) {
      const node = children[i];
      const tag = node.nodeType === 1 ? node.tagName : '';

      if (tag === 'H2') {
        result.push(node);
        i++;
      } else if (tag === 'H3') {
        const contentNodes = [];
        let j = i + 1;
        while (j < children.length) {
          const next = children[j];
          const nextTag = next.nodeType === 1 ? next.tagName : '';
          if (nextTag === 'H3' || nextTag === 'H2') break;
          contentNodes.push(next);
          j++;
        }
        result.push(faqBuildAccordion(node.textContent.trim(), contentNodes, isFirstGlobally));
        isFirstGlobally = false;
        i = j;
      } else {
        result.push(node);
        i++;
      }
    }

    body.innerHTML = '';
    for (const node of result) body.appendChild(node);
  }

  function faqUpgradeSection(section) {
    for (const body of section.querySelectorAll('[data-faq-accordion]')) {
      faqUpgradeBody(body);
    }
  }

  // Initial page load (defer script — DOM already parsed)
  for (const body of document.querySelectorAll('[data-faq-accordion]')) {
    faqUpgradeBody(body);
  }

  // Theme editor: re-run when section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    faqUpgradeSection(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-carousel-slide-mab"] && !Shopify.designMode) return;
  try {
    /* Re-trigger staggered slide-in on each carousel transition */
  (function () {
    function animateSlide(slideEl) {
      const text = slideEl && slideEl.querySelector('[data-slide-text]');
      if (!text) return;
      text.classList.remove('is-entering');
      void text.offsetWidth; /* force reflow to restart keyframes */
      text.classList.add('is-entering');
    }

    /* Heritage fires slideshow:select (bubbles) on every slide change */
    document.addEventListener('slideshow:select', function (e) {
      if (e.detail && e.detail.slide) animateSlide(e.detail.slide);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-band-mab"] && !Shopify.designMode) return;
  try {
    /* The band's CTA points at a named span the layout emits at the top of the footer. A fragment
     link scrolls to its target but never focuses a form control, so the reader landed beside the
     newsletter field with the caret still nowhere — on every page, including the home page.

     Focus first with preventScroll, then scroll deliberately. Doing it in that order keeps the two
     from fighting: focus() on its own would jump the viewport to wherever the browser thinks the
     element is, mid-scroll. */
  (() => {
    const TRIGGER = 'a[href="#newsletter-form"]';
    const FIELD = '.email-signup-block input[type="email"], input[name="contact[email]"]';

    const reveal = (field) => {
      if (!field) return false;
      field.focus({ preventScroll: true });
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      field.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      return true;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.(TRIGGER);
      if (!trigger) return;
      /* No field on this page means the fragment jump is still the best available behaviour, so
         leave the default alone rather than swallowing the click. */
      if (!reveal(document.querySelector(FIELD))) return;
      event.preventDefault();
      /* Keep the hash so a refresh or a shared link lands in the same place, without the second
         jump that assigning location.hash would cause. */
      history.replaceState(null, '', '#newsletter-form');
    });

    /* Arriving from another page with the fragment already in the URL. */
    if (window.location.hash === '#newsletter-form') {
      const arrive = () => reveal(document.querySelector(FIELD));
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', arrive, { once: true });
      } else {
        arrive();
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
